import { saveAs } from "file-saver";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useContext, useEffect, useState } from "react";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { FaFileExcel, FaFilePdf, FaMapMarkerAlt, FaPaperPlane } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import Select from 'react-select'; // 🔹 You forgot this
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';
import { refeshPend } from "../../../App";
import { getApi } from "../../Admin Master/Area Control/Zonemaster/ServicesApi";



function CustomerWiseReport() {
  const { docket, setDocket } = useContext(refeshPend);
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const [EmailData, setEmailData] = useState([]);
  const [getCustomer, setGetCustomer] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);

  const login = JSON.parse(localStorage.getItem("Login"));
  const [selectedDockets, setSelectedDockets] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [getBranch, setGetBranch] = useState([]);
  const [formData, setFormData] = useState({
    fromdt: firstDayOfMonth,
    todt: today,
    CustomerName: "",
    status: "",
    branch: login?.Branch_Code,
  });

  const getStatus = [
  { value: "Intransit", label: "Intransit" },
  { value: "OutForDelivery", label: "OutForDelivery" },
  { value: "Delivered", label: "Delivered" },
  { value: "RTO", label: "RTO" },
  { value: "Shipment Booked", label: "Shipment Booked" },
  ];
  useEffect(() => {
    if (getCustomer.length === 0) return;


    const customer = getCustomer.find(
      c => c.Customer_Code === login?.Customer_Code
    );

    if (customer) {
      setFormData(prev => ({
        ...prev,
        CustomerName: customer.Customer_Name,
      }));
    }
  }, [getCustomer]);

useEffect(() => {

  const login = JSON.parse(localStorage.getItem("Login"));


  setFormData(prev => ({
    ...prev,
    branch: login?.Branch_Code,
  }));


}, []);

const loginCustomerCode = JSON.parse(localStorage.getItem("Login"))?.Customer_Code;
const allOptions =
  
    [
      ...getCustomer.map((cust) => ({
        label: cust.Customer_Name,
        value: cust.Customer_Name,
      })),
    ]
    

const branchOptions =

  [
    ...getBranch.map(city => ({
      value: city.Branch_Code,   // adjust keys from your API
      label: city.Branch_Name,
    }))
  ]

useEffect(() => {

  fetchCustomerData(formData.branch)

}, [formData.branch])





const formatDate = (date) => {
  if (!date) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${day}/${month}/${year}`;
};




const fetchBranchData = async () => {
  try {
    const response = await getApi(
      `/Master/GetAllBranchData?Branch_Code=${JSON.parse(localStorage.getItem('Login'))?.Branch_Code}`
    );

    let data = Array.isArray(response.Data) ? response.Data : [];


    setGetBranch(data);
  } catch (err) {
    console.error('Fetch Error:', err);
    setError(err);
  } finally {
    setLoading(false);
  }
};


const fetchCustomerData = async (branch) => {
  try {
    const response = await getApi(`/Master/getCustomerdata?Branch_Code=${branch}&Customer_Code=${login?.Customer_Code}`)
    setGetCustomer(Array.isArray(response.Data) ? response.Data : []);
  } catch (err) {
    setError(err);
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  fetchBranchData();
  // fetchCustomerData();
}, []);



const handleSearchChange = (selectedOption) => {
  setFormData({ ...formData, CustomerName: selectedOption ? selectedOption.value : "" });
};

const handlesave = async (e) => {
  e.preventDefault();
  const fromdt = formatDate(formData.fromdt);
  const todt = formatDate(formData.todt);
  const CustomerName = formData.CustomerName;
  const status = formData.status;
  const branch = formData.branch || "All Branch ";

  if (!fromdt || !todt) {
    Swal.fire('Error', 'Both From Date and To Date are required.', 'error');
    return;
  }

  try {
    const response = await getApi(
      `Booking/StatusReport?CustomerName=${encodeURIComponent(CustomerName)}&Status=${encodeURIComponent(status)}&fromdt=${encodeURIComponent(fromdt)}&todt=${encodeURIComponent(todt)}&Branch_Name=${encodeURIComponent(branch)}&pageNumber=${encodeURIComponent(currentPage)}&pageSize=${encodeURIComponent(rowsPerPage)}`
    );

    if (response.status === 1) {
      setEmailData(response.Data);
      setSelectedDockets([]);
      setCurrentPage(1);
      Swal.fire('Saved!', 'Data has been fetched.', 'success');
    }
  } catch (error) {
    console.error("API Error:", error);
    setEmailData([]);
    Swal.fire('No Data', 'No records found.', 'info');
  }
};

const indexOfLastRow = currentPage * rowsPerPage;
const indexOfFirstRow = indexOfLastRow - rowsPerPage;
const currentRows = EmailData.slice(indexOfFirstRow, indexOfLastRow);
const totalPages = Math.ceil(EmailData.length / rowsPerPage);

const exportSelectedToPDF = () => {
  if (selectedDockets.length === 0) {
    Swal.fire("Error", "Please select at least one docket", "error");
    return;
  }

  const selectedData = EmailData.filter((row) =>
    selectedDockets.includes(row.DocketNo)
  );

  const doc = new jsPDF();

  const headers = [
    [
      "DocketNo",
      "Book Date",
      "Customer",
      "Consignee",
      "Origin",
      "Destination",
      "Mode",
      "Qty",
      "Weight",
    ],
  ];

  const body = selectedData.map((item) => [
    item.DocketNo,
    item.BookDate ? new Date(item.BookDate).toLocaleDateString("en-GB") : "",
    item.Customer_Name,
    item.Consignee_Name,
    item.Origin_Name,
    item.Destination_Name,
    item.Mode_Name,
    item.Qty,
    item.ActualWt,
  ]);

  doc.text("Selected Booking Data", 14, 10);
  doc.autoTable({
    head: headers,
    body,
    startY: 20,
  });

  doc.save("SelectedDockets.pdf");
};

const exportSelectedToExcel = () => {
  if (currentRows.length === 0) {
    Swal.fire("Error", "No data available on this page to export", "error");
    return;
  }

  const formattedData = currentRows.map(row => ({
    ...row,
    BookDate: row.BookDate ? new Date(row.BookDate).toLocaleDateString("en-GB") : "",
  }));
  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "CurrentPageData");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(data, `CurrentPageData_Page${currentPage}.xlsx`);
};

const handleSendEmailWithAttachment = async (fileType) => {
  const fromDate = formatDate(formData.fromdt);
  const toDate = formatDate(formData.todt);
  const customerName = formData.CustomerName;


  if (!customerName || !fromDate || !toDate) {
    Swal.fire('Error', 'Please fill all fields.', 'error');
    return;
  }

  try {
    const response = await getApi(`/Master/sendBookingExcelEmail?CustomerName=${encodeURIComponent(customerName)}&fromdt=${fromDate}&todt=${toDate}&recipientEmail=futureinfosyso@gmail.com&fileType=${fileType}`);

    const result = await response.json();
    if (result.status === 1) {
      Swal.fire('Success', result.message, 'success');
    } else {
      Swal.fire('Error', result.message, 'error');
    }
  } catch (error) {
    console.error('Email send failed:', error);
    Swal.fire('Error', 'Server error occurred.', 'error');
  }
};

const handleDateChange = (date, field) => {
  setFormData({ ...formData, [field]: date });
};

return (
  <div className="body">
    <div className="container1">
      <form onSubmit={handlesave}>
        {/* 🔹 First Row: Dropdowns */}
        <div className="fields2">
          {/* Branch */}
          <div className="input-field2">
            <label >Branch</label>
            <Select
              required
              options={branchOptions}
              value={formData.branch ? branchOptions.find(c => c.value === formData.branch) : null}
              onChange={(selectedOption) =>
                setFormData({ ...formData, branch: selectedOption ? selectedOption.value : "" })
              }
              placeholder="Select Branch"
              isSearchable
              classNamePrefix="blue-selectbooking"
              className="blue-selectbooking"
              menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
              styles={{
                placeholder: (base) => ({
                  ...base,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                }),
                menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
              }}
            />
          </div>

          {/* Client Name */}
          <div className="input-field1">
            <label >Client Name</label>
            <Select
              className="blue-selectbooking"
              classNamePrefix="blue-selectbooking"
              options={allOptions}
              isSearchable
              value={formData.CustomerName ? { label: formData.CustomerName, value: formData.CustomerName } : null}
              onChange={handleSearchChange}
              placeholder="Search Customer..."
              menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
              styles={{
                placeholder: (base) => ({
                  ...base,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                }),
                menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
              }}
            />
          </div>

          {/* Status */}
          <div className="input-field2">
            <label >Status</label>
            <Select
              className="blue-selectbooking"
              classNamePrefix="blue-selectbooking"
              options={getStatus}
              value={formData.status ? getStatus.find((item) => item.value === formData.status) : null}
              onChange={(selected) => setFormData({ ...formData, status: selected ? selected.value : "" })}
              placeholder="Search Status..."
              isSearchable
              menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
              styles={{
                placeholder: (base) => ({
                  ...base,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                }),
                menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
              }}
            />
          </div>

          <div className="input-field2">
            <label >From Date</label>
            <DatePicker
              selected={formData.fromdt}
              onChange={(date) => handleDateChange(date, "fromdt")}
              dateFormat="dd/MM/yyyy"
              className="form-control form-control-sm"
              portalId="root-portal"
            />
          </div>

          {/* To Date */}
          <div className="input-field2">
            <label >To Date</label>
            <DatePicker
              selected={formData.todt}
              onChange={(date) => handleDateChange(date, "todt")}
              dateFormat="dd/MM/yyyy"
              className="form-control form-control-sm"
              portalId="root-portal"
            />
          </div>


          <div style={{ display: "flex", justifyContent: "end", flexWrap: "wrap", gap: "10px", width: "100%", padding: "10px" }}>

            <button
              type="submit"
              style={{
                display: "flex", justifyContent: "center", gap: "5px",
                alignItems: "center", padding: "7px 12px", fontSize: "10px", borderRadius: "5px", border: "none"
              }}
              className="ok-btn"
            >
              <FaPaperPlane size={15} />
              <span>Submit</span>
            </button>

            <button
              style={{
                display: "flex", justifyContent: "center", gap: "5px",
                alignItems: "center", padding: "7px 12px", fontSize: "10px", borderRadius: "5px", border: "none"
              }}
              className="ok-btn"
              type="button"
              onClick={() => handleSendEmailWithAttachment("excel")}
            >
              <MdEmail size={15} />
              <span>Mail</span>
            </button>

            <button
              style={{
                display: "flex", justifyContent: "center", gap: "5px",
                alignItems: "center", padding: "7px 12px", fontSize: "10px", borderRadius: "5px", border: "none"
              }}
              className="ok-btn"
              type="button"

              onClick={exportSelectedToExcel}
            >
              <FaFileExcel size={15} />
              <span>Excel</span>
            </button>

            <button
              type="button"
              style={{
                display: "flex", justifyContent: "center", gap: "5px",
                alignItems: "center", padding: "7px 12px", fontSize: "10px", borderRadius: "5px", border: "none"
              }}
              className="ok-btn"
              onClick={exportSelectedToPDF}
            >
              <FaFilePdf size={15} />
              <span>PDF</span>
            </button>

          </div>
        </div>



      </form>

      {/* 📋 Table */}
      <div className='table-container'>
        <table className='table table-bordered table-sm' style={{ whiteSpace: "nowrap" }}>
          <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
            <tr>
              <th className="w-60">Sr.No</th>
              <th>DocketNo</th>
              <th>Book_Date</th>
              <th>Customer</th>
              <th>Consignee</th>
              <th>Origin</th>
              <th>Destination</th>
              <th>Mode</th>
              <th>Vendor</th>
              <th>Vendor_Docket</th>
              <th>Flag</th>
              <th>Qty</th>
              <th>Weight</th>
              <th>Track</th>
              <th>Status</th>
              <th>Delivery_Date</th>
              <th>Delivery_Time</th>
              <th>RecvName</th>
              <th>Remark</th>
            </tr>
          </thead>
          <tbody>
            {currentRows.length === 0 ? (
              <tr>
                <td colSpan="18" className="text-center text-danger">No Data Found</td>
              </tr>
            ) : (
              currentRows.map((item, index) => (
                <tr key={index}>
                  <td className="w-60">{indexOfFirstRow + index + 1}</td>

                  <td>
                    <button
                      type="button"
                      className="btn btn-link p-0"
                      style={{ fontSize: "14px", fontWeight: "bold", color: "#055a0f" }}

                      onClick={() => setDocket(item.DocketNo)}

                    >
                      {item.DocketNo}
                    </button></td>
                  <td>{item.BookDate ? new Date(item.BookDate).toLocaleDateString('en-GB') : ''}</td>
                  <td>{item.Customer_Name}</td>
                  <td>{item.Consignee_Name}</td>
                  <td>{item.Origin_Name}</td>
                  <td>{item.Destination_Name}</td>
                  <td>{item.Mode_Name}</td>
                  <td>{item.Vendor_Name}</td>
                  <td>{item.vendorAwbno}</td>
                  <td>{item.T_Flag}</td>
                  <td>{item.Qty}</td>
                  <td>{item.ActualWt}</td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-link p-0"
                      style={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "#034f03",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px"
                      }}
                      onClick={() => setDocket(item.DocketNo)}
                    >
                      <FaMapMarkerAlt style={{ color: "green" }} />
                    </button>
                  </td>
                  <td>{item.Status}</td>
                  <td>{item.DelvDT}</td>
                  <td>{item.DelvTime}</td>
                  <td>{item.RecvName}</td>
                  <td>{item.Remark}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="d-flex flex-column flex-md-row justify-content-md-between align-items-center w-100 gap-2 mt-2">
        {/* Rows per page dropdown */}
        <div className="d-flex align-items-center gap-2">
          <span className="mb-0">Rows per page:</span>
          <select
            className="form-select form-select-sm"
            style={{ width: "80px" }}
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1); // reset to first page
            }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={EmailData.length}>All</option>
          </select>
        </div>

        {/* Pagination */}
        <div className="d-flex align-items-center gap-2">
          <button
            className="ok-btn"
            style={{ width: "30px" }}
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            {"<"}
          </button>
          <span style={{ color: "#333", padding: "5px" }}>
            Page {currentPage} of {totalPages}
          </span>
          <button
            className="ok-btn"
            style={{ width: "30px" }}
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
          >
            {">"}
          </button>
        </div>
      </div>
    </div>
  </div>
);
}

export default CustomerWiseReport;
